import { render, staticRenderFns } from "./monitor-onCall.vue?vue&type=template&id=0489d93b&scoped=true"
import script from "./monitor-onCall.vue?vue&type=script&lang=js"
export * from "./monitor-onCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489d93b",
  null
  
)

export default component.exports